module.exports = __webpack_public_path__ + "static/media/js.14bd8ad0.svg";